/**
 * Blockstream Panel Component
 * Shows calendar for current user with day navigation
 * Currently not implemented - uses old calendar system
 */

import React from 'react';
import { Button, Result } from 'antd';
import { CloseOutlined, CalendarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './BlockstreamPanel.css';

interface BlockstreamPanelProps {
  isOpen: boolean;
  onClose: () => void;
  isInline?: boolean; // For use in modern layout
}

export const BlockstreamPanel: React.FC<BlockstreamPanelProps> = ({
  isOpen,
  onClose,
  isInline = false,
}) => {
  const navigate = useNavigate();

  if (!isOpen && !isInline) return null;

  return (
    <div
      className={`blockstream-panel ${isInline ? 'blockstream-inline' : ''} ${isOpen ? 'blockstream-open' : 'blockstream-closed'}`}
    >
      {/* Header */}
      <div className="blockstream-header">
        <div className="blockstream-header-title">
          <CalendarOutlined className="blockstream-icon" />
          <h3>Moj kalendar</h3>
        </div>
        {!isInline && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            className="blockstream-close"
          />
        )}
      </div>

      {/* Not Implemented Message */}
      <div
        className="blockstream-content"
        style={{
          padding: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Result
          icon={<CalendarOutlined style={{ fontSize: 48, color: '#1890ff' }} />}
          title="Not Implemented"
          subTitle="This calendar panel is currently under development. Please use the GoldenWings Calendar."
          extra={
            <Button
              type="primary"
              onClick={() => navigate('/apps/goldenwings/calendar')}
            >
              Go to GoldenWings Calendar
            </Button>
          }
        />
      </div>
    </div>
  );
};
